export default function () {
  const widgetName = 'cardWidgetSeoFeature';
  const widgetOpts = cardWidgetSeoFeatureOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (slide) {
      function addClass() {
        let data = `<div class="card-widget-subtitle">${slide.items[0].DetailLinkText}</div>`
        $(`#${widgetName} .card-widget-item`).each(function () {
          let dataUrl = ""
          $(this).find(".moreButton").addClass("button");
          $(this).find(".moreButton").removeClass("moreButton");
          $(this).find(".button").attr("target", "");
          $(this).find(".buyNowButton").addClass("button");
          dataUrl = $(this).find('.buyNowButton').attr('href');
          $(this).find(".image-container").wrap(`<a class="map-url" href="${dataUrl}" target="_blank"></a>`);
          $(this).find(".button").attr("target", "");
          $(this).find(".buyNowButton").attr("target", "_blank");
          $(this).find('.card-widget-title').before(data);
          $(this).find('.map-url .image-container').before(`
          <div class="map-mobile-title">
          <div class="card-widget-subtitle">Explore</div>
          <div class="card-widget-title">Attractions Map</div>
          </div>`)
        })
      }
      addClass()
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    buyNowButton: {
      visible: true,
      text: 'Explore the Map >'
    },
    buyNowButton: {
      visible: true,
      text: 'Explore the Map'
    },
    moreButton: {
      visible: true,
      text: 'Learn More'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false,
  });
}